import { Component, ViewEncapsulation, computed, input } from '@angular/core';

/**
 * This is the Image-Card Component. It renders a shaded panel that is divided in an image and a body.
 * An Image-Card can be layed-out horizontal or vertical.
 **/
@Component({
    selector: 'ap-image-card',
    templateUrl: './image-card.component.html',
    styleUrls: ['./image-card.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class ApImageCardComponent {
    /**
     * Required - Url of the image source (asset)
     */
    public readonly imageSource = input.required<string>();

    /**
     * Vertical or horizontal image card
     */
    public readonly type = input<'vertical' | 'horizontal'>('vertical');

    /**
     * Required - Alt text for the image
     */
    public readonly alt = input.required<string>();

    /**
     * Formatted value to display
     * @internal
     */
    protected readonly cardModifier = computed(() => `ap-card--${this.type()}`);
}
